module.exports = __webpack_public_path__ + "static/media/warehouse-03.fa973788.png";